export const translations = {
  pt: {
    // Header Menu (URLs em inglês, labels em português)
    advisory: 'Consultoria',
    services: 'Serviços',
    regions: 'Regiões',
    about: 'Consultoria', // legacy alias
    blog: 'Journal', // legacy alias
    journal: 'Journal',
    contact: 'Contacto',
    international: 'International',
    menu: 'Menu',
    close: 'Fechar',
    beginConversation: 'Iniciar conversa',
    privateAdvisory: 'Private Real Estate Advisory · Portugal',

    // Footer
    quickLinks: 'Links Rápidos',
    socialMedia: 'Redes Sociais',
    allRightsReserved: 'Todos os direitos reservados',
    privacyPolicy: 'Política de Privacidade',
    arbitrationCenter: 'Centro de Arbitragem',

    // Contact Form
    contactTitle: 'Contactos',
    contactSubtitle: 'Estamos disponíveis para compreender o seu projeto e encontrar o imóvel certo para si em Portugal.',
    informations: 'Informações',
    sendMessage: 'Envie-nos uma mensagem',
    name: 'Nome',
    email: 'Email',
    phone: 'Telefone',
    preferredLocation: 'Localização pretendida',
    priceRange: 'Faixa de preço',
    observations: 'Observações',
    privacyAccept: 'Li e aceito a',
    privacyPolicyLink: 'Política de Privacidade',
    sendButton: 'Enviar Mensagem',
    whatsappDirect: 'WhatsApp Direto',
    whatsappText: 'Converse já connosco em tempo real e partilhe o que procura.',
    openWhatsapp: 'Abrir WhatsApp',

    // Regions Section
    regionsTitle: 'Onde Atuamos',
    regionsSubtitle: 'Na Your Broker Portugal acreditamos que cada cliente merece mais do que uma listagem de imóveis: merece compreender os diferentes mercados e estilos de vida que Portugal oferece.',

    // Services Section
    servicesTitle: 'Nossos Serviços',

    // About Section
    aboutTitle: 'Sobre Nós',

    // Blog Section
    blogTitle: 'Your Broker Journal',
    blogSubtitle: 'Descubra as tendências do mercado residencial e comercial em Portugal',
    readMore: 'Ler mais',

    // Stats Section
    statsTitle: 'Números que falam por si',

    // Testimonials Section
    testimonialsTitle: 'O que dizem os nossos clientes',

    // Loading
    loading: 'Carregando...',
  },
  en: {
    // Header Menu (URLs and labels in English)
    advisory: 'Advisory',
    services: 'Services',
    regions: 'Regions',
    about: 'Advisory', // legacy alias
    blog: 'Journal', // legacy alias
    journal: 'Journal',
    contact: 'Contact',
    international: 'International',
    menu: 'Menu',
    close: 'Close',
    beginConversation: 'Begin a conversation',
    privateAdvisory: 'Private Real Estate Advisory · Portugal',

    // Footer
    quickLinks: 'Quick Links',
    socialMedia: 'Social Media',
    allRightsReserved: 'All rights reserved',
    privacyPolicy: 'Privacy Policy',
    arbitrationCenter: 'Arbitration Center',

    // Contact Form
    contactTitle: 'Contact Us',
    contactSubtitle: 'We are available to understand your project and find the right property for you in Portugal.',
    informations: 'Information',
    sendMessage: 'Send us a message',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    preferredLocation: 'Preferred location',
    priceRange: 'Price range',
    observations: 'Observations',
    privacyAccept: 'I have read and accept the',
    privacyPolicyLink: 'Privacy Policy',
    sendButton: 'Send Message',
    whatsappDirect: 'Direct WhatsApp',
    whatsappText: 'Chat with us in real time and share what you are looking for.',
    openWhatsapp: 'Open WhatsApp',

    // Regions Section
    regionsTitle: 'Where We Operate',
    regionsSubtitle: 'At Your Broker Portugal we believe that each client deserves more than a list of properties: they deserve to understand the different markets and lifestyles that Portugal offers.',

    // Services Section
    servicesTitle: 'Our Services',

    // About Section
    aboutTitle: 'About Us',

    // Blog Section
    blogTitle: 'Your Broker Journal',
    blogSubtitle: 'Discover the trends in the residential and commercial market in Portugal',
    readMore: 'Read more',

    // Stats Section
    statsTitle: 'Numbers that speak for themselves',

    // Testimonials Section
    testimonialsTitle: 'What our clients say',

    // Loading
    loading: 'Loading...',
  },
};
